module.exports = "https://redage.akamaized.net/src/views/games/other/images/maps/map_6.png";